export default {"src":"/_next/static/media/bgLogo.0330aa79.svg","height":142,"width":314,"blurWidth":0,"blurHeight":0};